import TypedNativeModules from '../internal/TypedNativeModules';

export type BridgeImplementations<K extends keyof typeof TypedNativeModules> = {
    [P in K]: Promise<(typeof TypedNativeModules)[P]>;
};

export function awaitBridges<K extends keyof typeof TypedNativeModules>(
    bridges: readonly K[],
): BridgeImplementations<K> {
    const initializers: Array<[K, Promise<(typeof TypedNativeModules)[K]>]> = bridges.map(
        (bridgeName) => [bridgeName, Promise.resolve(TypedNativeModules[bridgeName])],
    );

    return Object.fromEntries(initializers) as BridgeImplementations<K>;
}
